export const config = {
  screens: {
    TodayTeeSheetHack: "patron/todaysteesheet",
    Unauthenticated: {
      initialRouteName: "Initial",
      screens: {
        Initial: {
          path: "patron",
          parse: {
            routeAfterLogin: (routeAfterLogin: string) => routeAfterLogin,
          },
          stringify: {
            routeAfterLogin: (routeAfterLogin: string) =>
              encodeURIComponent(routeAfterLogin),
          },
        },
        Register: "patron/register/:token",
        Onboarding: "patron/onboarding",
        ForgotPassword: "patron/forgot-password",
        ResetPassword: "patron/reset-password/:token",
        SSOError: "patron/error",
      },
    },
    Club: {
      initialRouteName: "Home",
      path: "patron/club/:clubSlug",
      screens: {
        Home: {
          initialRouteName: "MainHome",
          path: "",
          screens: {
            MainHome: "/",
            Events: "events",
            Profile: {
              path: "profile",
              screens: {
                ProfileHome: "",
                Memberships: {
                  path: "memberships",
                  initialRouteName: "MembershipsList",
                  screens: {
                    MembershipsList: "",
                    MembershipDetail: "/:membershipId",
                    MembershipOrder: "/:membershipId/order/:orderId",
                  },
                },
                Packages: {
                  path: "packages",
                  initialRouteName: "PackageList",
                  screens: {
                    PackagesList: "",
                    PackageDetail: "/:packageId",
                    PackageOrder: "/:packageId/order/:orderId",
                  },
                },
              },
            },
          },
        },
        Lessons: {
          path: "lessons/:facilitySlug",
          parse: {
            facilitySlug: (facilitySlug: string) => {
              return decodeURIComponent(facilitySlug);
            },
          },
          screens: {
            LessonsHome: "",
            InstructorDetail: {
              path: "instructor/:instructorId",
              parse: {
                instructorId: (instructorId: string) =>
                  decodeURIComponent(instructorId),
              },
            },
          },
        },
        Agenda: "agenda/:facilitySlug?/:date?",
        DepartmentAvailability: "availability/:departmentSlug?/:date?",
        Store: {
          path: "store",
          initialRouteName: "StoreHome",
          screens: {
            StoreHome: "",
            Memberships: "memberships",
            Packages: "packages",
            ProductDetail: "product/:productId",
            ProductOrder: "product/:productId/order/:orderId",
          },
        },
        Login: {
          path: "login",
          parse: {
            routeAfterLogin: (routeAfterLogin: string) => routeAfterLogin,
          },
          stringify: {
            routeAfterLogin: (routeAfterLogin: string) =>
              encodeURIComponent(routeAfterLogin),
          },
        },
        BookingSummary: {
          path: "bookingSummary/:slotOrBookingId",
          alias: ["booking/:slotOrBookingId"],
          parse: {
            slotOrBookingId: (slotOrBookingId: string) => {
              return decodeURIComponent(slotOrBookingId);
            },
            fromUrl: (fromUrl: string) => fromUrl === "true",
          },
        },
        JoinBooking: {
          path: "join-booking/:joinableId",
          parse: {
            joinableId: (joinableId: string) => {
              return decodeURIComponent(joinableId);
            },
          },
        },
        MoveBooking: {
          path: "move-booking/:originalBookingId",
          parse: {
            originalBookingId: (originalBookingId: string) => {
              return decodeURIComponent(originalBookingId);
            },
          },
        },
        MoveDiningBooking: {
          path: "move-dining-booking/:bookingId",
          parse: {
            bookingId: (bookingId: string) => {
              return decodeURIComponent(bookingId);
            },
            date: (date: string) => {
              try {
                return decodeURIComponent(date);
              } catch (_error) {
                return date;
              }
            },
          },
          stringify: {
            date: (date: string) => encodeURIComponent(date),
          },
        },
        EventDetail: {
          path: "event-detail/:eventID",
          parse: {
            eventID: (eventID: string) => {
              const parsed = decodeURIComponent(eventID);
              return parsed;
            },
          },
          screens: {
            EventDetailHome: "",
            AddGroup: "/add-group",
          },
        },
        EventSignupSummary: {
          path: "event-detail/:eventID/signup/:signUpId",
          parse: {
            eventID: (eventID: string) => {
              return decodeURIComponent(eventID);
            },
            signUpId: (signUpId: string) => {
              return decodeURIComponent(signUpId);
            },
          },
        },
        WebView: {
          path: "webview/:url/:title",
          parse: {
            url: (url: string) => decodeURIComponent(url),
            title: (title: string) => decodeURIComponent(title),
          },
        },
      },
    },
    NoNav: "/patron/nonav/*",
    Legacy: "/members/*",
    NotFound: "*",
  },
};
